"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEnumValue = exports.UserTaskFormField = exports.UserTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN UserTask.
 *
 * A user task will hold the current execution of the process and wait for user input
 * before continuing.
 */
class UserTask extends ActivityBase_1.Activity {
    get bpmnType() {
        return Constants_1.BpmnType.userTask;
    }
}
exports.UserTask = UserTask;
/**
 * Describes a BPMN FormField.
 * A FormField is part of a UserTask and can contain all kinds of values.
 *
 * These values can then be used to finish the UserTask.
 */
class UserTaskFormField {
}
exports.UserTaskFormField = UserTaskFormField;
/**
 * Used in combination with 'enum' type UserTask FormFields,
 * this describes a single enum value of that FormField.
 */
class FormFieldEnumValue {
}
exports.FormFieldEnumValue = FormFieldEnumValue;
//# sourceMappingURL=UserTask.js.map